/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Scope_Detail5Inputs */

const en_svc_retainer_scope_detail5 = /** @type {(inputs: Svc_Retainer_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systems covered, response times and monthly capacity.`)
};

const ar_svc_retainer_scope_detail5 = /** @type {(inputs: Svc_Retainer_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدد النطاق والجدول والسعر الثابت في مستند واحد.`)
};

const bn_svc_retainer_scope_detail5 = /** @type {(inputs: Svc_Retainer_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোন সিস্টেম, প্রতিক্রিয়া সময় আর মাসিক ক্ষমতা।`)
};

const de_svc_retainer_scope_detail5 = /** @type {(inputs: Svc_Retainer_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgedeckte Systeme, Reaktionszeiten und monatliche Kapazität.`)
};

const es_svc_retainer_scope_detail5 = /** @type {(inputs: Svc_Retainer_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistemas cubiertos, tiempos de respuesta y capacidad mensual.`)
};

const fr_svc_retainer_scope_detail5 = /** @type {(inputs: Svc_Retainer_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systèmes couverts, délais de réponse et capacité mensuelle.`)
};

const pt_svc_retainer_scope_detail5 = /** @type {(inputs: Svc_Retainer_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistemas cobertos, tempos de resposta e capacidade mensal.`)
};

const zh_svc_retainer_scope_detail5 = /** @type {(inputs: Svc_Retainer_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`覆盖哪些系统、响应时效和每月额度。`)
};

const tr_svc_retainer_scope_detail5 = /** @type {(inputs: Svc_Retainer_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapsanan sistemler, yanıt süreleri ve aylık kapasite.`)
};

const ru_svc_retainer_scope_detail5 = /** @type {(inputs: Svc_Retainer_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Покрываемые системы, время реакции и месячная ёмкость.`)
};

const pl_svc_retainer_scope_detail5 = /** @type {(inputs: Svc_Retainer_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systemy objęte, czasy reakcji i miesięczna pojemność.`)
};

/**
* | output |
* | --- |
* | "Systems covered, response times and monthly capacity." |
*
* @param {Svc_Retainer_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_scope_detail5 = /** @type {((inputs?: Svc_Retainer_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_retainer_scope_detail5(inputs)
	if (locale === "de") return de_svc_retainer_scope_detail5(inputs)
	if (locale === "es") return es_svc_retainer_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_retainer_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_retainer_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_retainer_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_retainer_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_retainer_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_retainer_scope_detail5(inputs)
	return en_svc_retainer_scope_detail5(inputs)
});
export { svc_retainer_scope_detail5 as "svc_retainer_SCOPE_detail" }